import { render, staticRenderFns } from "./PollResult.vue?vue&type=template&id=c7602c2a&"
import script from "./PollResult.vue?vue&type=script&lang=js&"
export * from "./PollResult.vue?vue&type=script&lang=js&"
import style0 from "./PollResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports